import axios from "axios";

export default {
  async findCity(formData) {
    return axios.get(`/addresses/find-city/${formData.zip}`);
  },
};
